import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom"
import LandingPage from "../pages/landingPage/LandingPage"

export default function RoutesConfig () {

    const router = createBrowserRouter([
        {
          path: "/",
          element: <LandingPage />,
        },
    ])
    
    return (
        <RouterProvider router={router} />
    )
}